export default __webpack_public_path__ + "media/images/fonts/Flaticon-ba5087ddc172beb5563e19f7203b9eed.woff";